<template>
	<ViewPhoto
		v-if="imageShow && images.length"
		:key="photosIndex"
		:images="images"
		:index="photosIndex"
		@close="imageShow = false"
	/>
	<DaModalFrame v-model:open="open">
		<Withdraw
			v-if="open"
			@close="cancel"
			@submit="withdrawFeeNotification"
		/>
	</DaModalFrame>
	<DaModalFrame v-model:open="modalIsOpen">
		<ConfirmSendFeeNotice
			v-if="modalType === type.CREATE && notificationConfirm"
			:in-progress="inProgress"
			:notification="{
				...notificationConfirm,
				notice: {
					...notificationConfirm.notice,
					files,
					images,
				},
			}"
			is-network
			@close="cancel"
			@openViewPhoto="openMediaPopup(0)"
			@submit="sendNotification"
		/>
		<ConfirmResend
			v-if="modalType === type.UPDATE"
			:times="lastSendAt"
			@close="cancel"
			@submit="reSendNotification"
		/>
		<DeleteConfirm
			v-if="modalType === type.DELETE"
			@close="cancel"
			@submit="deleteNotification"
		/>
	</DaModalFrame>
	<div :class="sideOverShow ? 'side-over--active' : ''">
		<div
			v-if="sideOverShow"
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			@click="sideOverShow = false"
		></div>
		<CreateNotify
			:open="sideOverShow"
			@close="sideOverShow = false"
			:notification="notice"
		/>
	</div>
	<div class="pb-30 px-10 md-down:px-4">
		<div
			class="__report-lesson__header pt-10 pb-10 flex flex-nowrap justify-between items-center"
		>
			<div
				class="__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl cursor-pointer"
				@click="$router.push('/fee-notices')"
			>
				<svg
					class="mr-2"
					fill="none"
					height="28"
					viewBox="0 0 28 28"
					width="28"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M17.5 7L10.5 14L17.5 21"
						stroke="#94A3B8"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
					/>
				</svg>
				Chi tiết thông báo học phí
			</div>
			<div class="flex items-center justify-end gap-6">
				<div
					class="flex items-center text-yellow-600 hover:text-yellow-700 font-semibold cursor-pointer text-sm"
					v-if="notification?.notice?.state === 'draft'"
					@click="deleteOpen"
				>
					<svg
						class="mr-2"
						fill="none"
						height="16"
						viewBox="0 0 16 16"
						width="16"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							clip-rule="evenodd"
							d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
							fill="currentColor"
							fill-rule="evenodd"
						/>
					</svg>
					<span class="mt-0.5">Xoá</span>
				</div>
				<div
					class="flex items-center text-yellow-600 hover:text-yellow-700 font-semibold cursor-pointer text-sm"
					v-if="notification?.tuition_notice_id"
					@click="editNotify"
				>
					<svg
						class="mr-2"
						fill="none"
						height="16"
						viewBox="0 0 16 16"
						width="16"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							clip-rule="evenodd"
							d="M12.4702 6.65078L13.7102 5.41075C13.8461 5.27489 13.914 5.20696 13.9667 5.14499C14.6009 4.39832 14.6009 3.30214 13.9667 2.55546C13.914 2.4935 13.8461 2.42557 13.7102 2.28971C13.5744 2.15385 13.5064 2.08592 13.4445 2.03329C12.6978 1.39906 11.6016 1.39906 10.855 2.03329C10.793 2.08591 10.7251 2.15382 10.5893 2.28961L10.5892 2.28969L10.5892 2.28971L9.33099 3.54792C10.0747 4.84212 11.1583 5.91739 12.4702 6.65078ZM7.87633 5.00258L2.86273 10.0162C2.43767 10.4412 2.22514 10.6538 2.0854 10.9149C1.94567 11.176 1.88672 11.4707 1.76883 12.0601L1.37318 14.0384C1.30666 14.371 1.27339 14.5373 1.368 14.6319C1.46261 14.7266 1.62892 14.6933 1.96153 14.6268L3.9398 14.2311L3.93982 14.2311L3.93984 14.2311C4.52927 14.1132 4.82399 14.0543 5.08508 13.9145C5.34617 13.7748 5.55869 13.5623 5.98373 13.1373L5.98376 13.1372L5.98377 13.1372L11.0118 8.10922C9.7511 7.31101 8.68202 6.24913 7.87633 5.00258Z"
							fill="currentColor"
							fill-rule="evenodd"
						/>
					</svg>
					<span class="mt-0.5">Chỉnh sửa</span>
				</div>
			</div>
		</div>
		<div class="bg-white rounded-xl p-6 shadow-sm">
			<div class="flex items-center gap-4">
				<img
					:src="currentOrg.profile_photo.w200"
					alt="Tuition template"
					class="h-16 rounded-lg"
				/>
				<div>
					<div class="font-semibold">{{ currentOrg.name }}</div>
					<div class="text-sm text-neutral-500">
						{{ currentOrg.address }}
					</div>
				</div>
			</div>
			<div v-if="tuition !== null">
				<div class="flex items-center justify-center flex-col">
					<div class="font-semibold text-2xl">
						{{ tuition.title }}
					</div>
					<div
						class="text-sm italic text-neutral-500"
						v-if="notification.notice?.sent_at"
					>
						{{ formatData(notification.notice?.inserted_at) }}
					</div>
				</div>
				<div class="flex items-start mt-8">
					<div class="w-1/2">
						<div class="text-sm text-neutral-700">
							Học sinh: {{ tuition?.student?.name }}
						</div>
						<div
							class="text-sm text-neutral-700 mt-4"
							v-if="tuition?.day_care_class?.name"
						>
							Lớp bán trú: {{ tuition?.day_care_class?.name }}
						</div>
						<div
							class="text-sm text-neutral-700 mt-4 flex gap-1"
							v-if="
								tuition?.group_classes &&
								tuition?.group_classes.length > 0
							"
						>
							<div>Lớp nhóm:</div>
							<div>
								<div
									v-for="gClass in tuition?.group_classes"
									:key="gClass.id"
								>
									{{ gClass.name }}
								</div>
							</div>
						</div>
					</div>
					<div
						class="w-1/2"
						v-if="tuition?.data?.schedule_statistics.length > 0"
					>
						<div class="text-sm font-semibold text-neutral-700">
							Thống kê chuyên cần
						</div>
						<div class="flex items-center flex-wrap mt-4 gap-4">
							<div
								class="text-sm text-neutral-700 w-statistic"
								v-for="i in tuition?.data?.schedule_statistics"
								:key="i"
							>
								{{ i.name }}: {{ i.count }}
							</div>
						</div>
					</div>
				</div>
				<div class="flex justify-between items-center mt-4">
					<div class="text-gray-600 font-semibold text-lg">
						Nội dung thông báo
					</div>
					<div class="flex items-center justify-end gap-8">
						<div
							class="w-30 bg-white border-neutral-200 flex items-center md-down:mt-6"
							v-if="notification?.notice?.state === 'draft'"
						>
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M2.49992 0C1.57944 0 0.833252 0.746192 0.833252 1.66667V18.3333C0.833252 19.2538 1.57944 20 2.49992 20H10.5902C9.20618 18.7784 8.33325 16.9231 8.33325 14.9319C8.33325 11.25 11.318 8.33333 14.9999 8.33333C15.884 8.33333 16.7279 8.50542 17.4999 8.81793V1.66667C17.4999 0.746192 16.7537 0 15.8333 0H2.49992ZM2.49992 7.08333C2.2698 7.08333 2.08325 7.26988 2.08325 7.5C2.08325 7.73012 2.2698 7.91667 2.49992 7.91667H10.4166C10.6467 7.91667 10.8333 7.73012 10.8333 7.5C10.8333 7.26988 10.6467 7.08333 10.4166 7.08333H2.49992ZM2.49992 9.58333C2.2698 9.58333 2.08325 9.76988 2.08325 10C2.08325 10.2301 2.2698 10.4167 2.49992 10.4167H8.74992C8.98004 10.4167 9.16658 10.2301 9.16658 10C9.16658 9.76988 8.98004 9.58333 8.74992 9.58333H2.49992ZM2.49992 12.0833C2.2698 12.0833 2.08325 12.2699 2.08325 12.5C2.08325 12.7301 2.2698 12.9167 2.49992 12.9167H7.08325C7.31337 12.9167 7.49992 12.7301 7.49992 12.5C7.49992 12.2699 7.31337 12.0833 7.08325 12.0833H2.49992ZM2.49992 14.5833C2.2698 14.5833 2.08325 14.7699 2.08325 15C2.08325 15.2301 2.2698 15.4167 2.49992 15.4167H5.41658C5.6467 15.4167 5.83325 15.2301 5.83325 15C5.83325 14.7699 5.6467 14.5833 5.41658 14.5833H2.49992ZM2.91659 2.91667C2.45635 2.91667 2.08325 3.28976 2.08325 3.75C2.08325 4.21024 2.45635 4.58333 2.91659 4.58333H14.1666C14.6268 4.58333 14.9999 4.21024 14.9999 3.75C14.9999 3.28976 14.6268 2.91667 14.1666 2.91667H2.91659Z"
									fill="#94A3B8"
								/>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M19.9999 15C19.9999 17.7614 17.7613 20 14.9999 20C12.2385 20 9.99992 17.7614 9.99992 15C9.99992 12.2386 12.2385 10 14.9999 10C17.7613 10 19.9999 12.2386 19.9999 15ZM13.3459 12.904C13.2239 12.782 13.026 12.782 12.9039 12.904C12.7819 13.0261 12.7819 13.2239 12.9039 13.346L14.558 15L12.9039 16.654C12.7819 16.7761 12.7819 16.9739 12.9039 17.096C13.026 17.218 13.2239 17.218 13.3459 17.096L14.9999 15.4419L16.6539 17.096C16.776 17.218 16.9739 17.218 17.0959 17.096C17.2179 16.9739 17.2179 16.7761 17.0959 16.654L15.4419 15L17.0959 13.346C17.2179 13.2239 17.2179 13.0261 17.0959 12.904C16.9739 12.782 16.776 12.782 16.6539 12.904L14.9999 14.5581L13.3459 12.904Z"
									fill="#94A3B8"
								/>
							</svg>
							<div
								class="ml-2 text-sm text-neutral-600 whitespace-nowrap"
							>
								Bản nháp
							</div>
						</div>
						<div
							class="w-30 bg-white border-neutral-200 flex items-center md-down:mt-6"
							v-else-if="
								notification?.notice?.state === 'withdrawn'
							"
						>
							<svg
								width="19"
								height="20"
								viewBox="0 0 19 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M1.65217 0C0.739703 0 0 0.746192 0 1.66667V18.3333C0 19.2538 0.739704 20 1.65217 20H9.67212C8.30012 18.7784 7.43478 16.9231 7.43478 14.9319C7.43478 11.25 10.3936 8.33333 14.0435 8.33333C14.9199 8.33333 15.7564 8.50542 16.5217 8.81793V1.66667C16.5217 0.746192 15.782 0 14.8696 0H1.65217ZM1.65217 7.08333C1.42406 7.08333 1.23913 7.26988 1.23913 7.5C1.23913 7.73012 1.42406 7.91667 1.65217 7.91667H9.5C9.72812 7.91667 9.91304 7.73012 9.91304 7.5C9.91304 7.26988 9.72812 7.08333 9.5 7.08333H1.65217ZM1.65217 9.58333C1.42406 9.58333 1.23913 9.76988 1.23913 10C1.23913 10.2301 1.42406 10.4167 1.65217 10.4167H7.84783C8.07594 10.4167 8.26087 10.2301 8.26087 10C8.26087 9.76988 8.07594 9.58333 7.84783 9.58333H1.65217ZM1.65217 12.0833C1.42406 12.0833 1.23913 12.2699 1.23913 12.5C1.23913 12.7301 1.42406 12.9167 1.65217 12.9167H6.19565C6.42377 12.9167 6.6087 12.7301 6.6087 12.5C6.6087 12.2699 6.42377 12.0833 6.19565 12.0833H1.65217ZM1.65217 14.5833C1.42406 14.5833 1.23913 14.7699 1.23913 15C1.23913 15.2301 1.42406 15.4167 1.65217 15.4167H4.54348C4.7716 15.4167 4.95652 15.2301 4.95652 15C4.95652 14.7699 4.7716 14.5833 4.54348 14.5833H1.65217ZM2.06522 2.91667C1.60898 2.91667 1.23913 3.28976 1.23913 3.75C1.23913 4.21024 1.60898 4.58333 2.06522 4.58333H13.2174C13.6736 4.58333 14.0435 4.21024 14.0435 3.75C14.0435 3.28976 13.6736 2.91667 13.2174 2.91667H2.06522Z"
									fill="#E37056"
								/>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M14.0435 20C16.7809 20 19 17.7614 19 15C19 12.2386 16.7809 10 14.0435 10C11.3061 10 9.08696 12.2386 9.08696 15C9.08696 17.7614 11.3061 20 14.0435 20ZM11.5652 15C11.5652 14.7699 11.7501 14.5833 11.9783 14.5833H16.3152C16.5433 14.5833 16.7283 14.7699 16.7283 15C16.7283 15.2301 16.5433 15.4167 16.3152 15.4167H11.9783C11.7501 15.4167 11.5652 15.2301 11.5652 15Z"
									fill="#E37056"
								/>
							</svg>
							<div
								class="ml-2 text-sm text-neutral-600 whitespace-nowrap"
							>
								Đã thu hồi
							</div>
						</div>
						<div
							v-else
							class="w-30 bg-white border-neutral-200 flex items-center md-down:mt-6"
						>
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M17.4729 3.29087L12.482 17.2255C12.4224 17.3902 12.2661 17.4999 12.091 17.5H11.9579C11.7946 17.5 11.6458 17.4061 11.5753 17.2587L9.61218 13.0992C9.32311 12.4859 9.435 11.7586 9.895 11.2606L12.3905 8.53194C12.5436 8.37126 12.5436 8.1186 12.3905 7.95792L12.0744 7.64179C11.9137 7.48861 11.6611 7.48861 11.5004 7.64179L8.77204 10.1375C8.27411 10.5976 7.54687 10.7095 6.9337 10.4204L2.77457 8.45707C2.61418 8.39667 2.50588 8.24569 2.50007 8.07439V7.94128C2.48534 7.7541 2.59781 7.58026 2.77457 7.517L16.7077 2.5255C16.8575 2.47049 17.0255 2.50605 17.1402 2.61701L17.3565 2.83331C17.4865 2.94689 17.5328 3.12896 17.4729 3.29087Z"
									fill="#2AA797"
								/>
							</svg>
							<div
								class="ml-2 text-sm text-neutral-600 whitespace-nowrap"
							>
								Thông báo đã gửi
							</div>
						</div>
					</div>
				</div>
				<div class="mt-4">
					<div v-for="(form, i) in forms" :key="i">
						<div class="w-fit min-w-full">
							<table class="min-w-full text-neutral-200">
								<thead class="h-12">
									<tr>
										<th
											class="px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap border"
											scope="col"
										>
											STT
										</th>
										<th
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap border"
											scope="col"
										>
											{{
												i === 0
													? ' Khoản Thu'
													: 'Hoàn Phí'
											}}
										</th>
										<th
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap border"
											scope="col"
										>
											Chi phí (VNĐ)
										</th>
										<th
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap border"
											scope="col"
											v-if="
												data?.settings
													?.enabled_show_original_price
											"
										>
											Chi phí sau giảm giá (VNĐ)
										</th>
										<th
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap border"
											scope="col"
										>
											Số lượng
										</th>
										<th
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap border"
											scope="col"
										>
											Thành tiền (VNĐ)
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(item, index) in form"
										:key="item.id"
										class="text-neutral-700"
									>
										<td class="border">
											<div
												class="px-3 py-4 text-center text-neutral-700"
											>
												{{ index + 1 }}
											</div>
										</td>
										<td
											class="px-3 py-4 text-neutral-700 cursor-pointer border"
											style="max-width: 200px"
										>
											{{
												item?.custom_name
													? item?.custom_name
													: item?.name
											}}
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700 border"
										>
											<div>
												{{
													item.label ===
														'additional_charges' ||
													item.label ===
														'additional_refund'
														? $filters.priceFormat(
																item.price
														  )
														: data?.settings
																?.enabled_show_original_price
														? $filters.priceFormat(
																item.original_price
														  )
														: $filters.priceFormat(
																item.price
														  )
												}}
											</div>
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700 border"
											v-if="
												data?.settings
													?.enabled_show_original_price
											"
										>
											<div
												v-if="
													item.original_price ===
														item.price ||
													item.label ===
														'additional_charges' ||
													item.label ===
														'additional_refund'
												"
											>
												-
											</div>
											<div v-else>
												{{
													$filters.priceFormat(
														item.price
													)
												}}
											</div>
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700 border"
										>
											{{
												$filters.priceFormat(item.count)
											}}
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700 border"
										>
											{{
												$filters.priceFormat(item.total)
											}}
										</td>
									</tr>
								</tbody>
							</table>
							<div
								class="capitalize h-12 flex items-center justify-between bg-neutral-100 border-l border-r px-4 font-semibold text-neutral-500"
							>
								<div>
									Tổng
									{{ i === 0 ? ' Khoản Thu' : 'Hoàn Phí' }}
								</div>
								<div>
									{{ $filters.priceFormat(form.total) }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="capitalize h-12 flex items-center justify-between border px-4 font-semibold text-lg text-neutral-500"
				>
					<div>Tổng chi phí phụ huynh phải đóng</div>
					<div>{{ $filters.priceFormat(total) }}</div>
				</div>
				<div
					class="flex justify-between border p-4 font-normal text-neutral-700 text-base"
					v-if="
						data?.settings?.enabled_common_note ||
						data?.settings?.enabled_qr_code
					"
				>
					<div
						v-if="data?.tuition_common_note?.content"
						v-html="
							data?.tuition_common_note?.content.replace(
								/\n/g,
								'<br />'
							)
						"
					></div>
					<img
						v-if="data?.tuition_common_note?.asset_url"
						style="width: 100px; height: 100px"
						:src="data?.tuition_common_note?.asset_url"
						alt=""
					/>
				</div>
				<div
					class="text-neutral-700 text-base mt-4"
					v-if="tuition?.note"
				>
					<span class="font-semibold">Ghi chú: </span
					>{{ tuition?.note }}
				</div>
			</div>
			<div class="rounded-lg p-4 border border-gray-100 mt-4" v-else>
				<div class="flex md-down:flex-col w-full gap-4">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						Tiêu đề
					</div>
					<div class="w-full font-semibold text-gray-700">
						{{ notification?.notice?.title }}
					</div>
				</div>
				<div class="flex md-down:flex-col w-full gap-4 mt-8">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						nội dung
					</div>
					<div
						v-if="notification?.notice"
						class="w-full text-gray-700"
						v-html="
							formatUrl(notification.notice?.content)?.replace(
								/\n/g,
								'<br />'
							)
						"
					></div>
				</div>
				<div class="flex md-down:flex-col w-full gap-4 mt-8">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						TỆP ĐÍNH KÈM
					</div>
					<div class="w-full">
						<div
							class="w-full flex flex-col gap-4"
							v-if="notification?.notice?.notice_attachments"
						>
							<div
								class="grid grid-cols-2 gap-4"
								v-if="images.length"
							>
								<div
									v-for="(image, index) in images"
									:key="index"
									class="rounded-lg relative"
									@click="openMediaPopup(index)"
								>
									<div class="relative">
										<img
											:src="image.asset_url"
											alt=""
											class="rounded-lg object-fill h-full w-full"
											style="aspect-ratio: 4/3"
										/>
										<div
											class="absolute bg-black opacity-20 rounded-lg h-full w-full top-0 right-0"
										></div>
										<div class="absolute right-2 bottom-2">
											<a
												:href="image.asset_url"
												download
												target="_blank"
												class="flex items-center font-semibold text-sm text-blue-700 hover:text-blue-800 cursor-pointer ml-6 whitespace-nowrap"
											>
												<svg
													class="mr-2"
													width="20"
													height="20"
													viewBox="0 0 20 20"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M10 0C8.21698 0 6.6397 0.70057 5.5072 1.67727C4.54981 2.50296 3.85599 3.57713 3.67778 4.65625C1.58233 5.1189 0 6.94389 0 9.14773C0 11.7075 2.13442 13.75 4.72656 13.75H9.375V6.875C9.375 6.52982 9.65482 6.25 10 6.25C10.3452 6.25 10.625 6.52982 10.625 6.875V13.75H15.8594C18.1279 13.75 20 11.9619 20 9.71591C20 7.6707 18.4476 6.00513 16.4571 5.72373C16.1541 2.4993 13.3628 0 10 0Z"
														fill="currentColor"
													/>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M9.55806 19.8169C9.80214 20.061 10.1979 20.061 10.4419 19.8169L14.1919 16.0669C14.436 15.8229 14.436 15.4271 14.1919 15.1831C13.9479 14.939 13.5521 14.939 13.3081 15.1831L10.625 17.8661V13.75H9.375V17.8661L6.69194 15.1831C6.44786 14.939 6.05214 14.939 5.80806 15.1831C5.56398 15.4271 5.56398 15.8229 5.80806 16.0669L9.55806 19.8169Z"
														fill="currentColor"
													/>
												</svg>
												Tải xuống
											</a>
										</div>
									</div>
								</div>
							</div>
							<div
								v-if="files.length"
								class="mt-4 flex flex-col gap-2"
							>
								<div
									v-for="(file, index) in files"
									:key="index"
									class="flex justify-between items-center w-full"
								>
									<div
										class="text-neutral-400 flex items-center gap-2 truncate max-w-[30px]"
									>
										<svg
											width="24"
											height="32"
											viewBox="0 0 24 32"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M0 4C0 1.79086 1.79086 0 4 0H14.5858C15.1162 0 15.6249 0.210714 16 0.585786L23.4142 8C23.7893 8.37507 24 8.88378 24 9.41421V28C24 30.2091 22.2091 32 20 32H4C1.79086 32 0 30.2091 0 28V4ZM15 7V3L21 9H17C15.8954 9 15 8.10457 15 7ZM17.7071 15.7071C18.0976 15.3166 18.0976 14.6834 17.7071 14.2929C17.3166 13.9024 16.6834 13.9024 16.2929 14.2929L11 19.5858L8.70711 17.2929C8.31658 16.9024 7.68342 16.9024 7.29289 17.2929C6.90237 17.6834 6.90237 18.3166 7.29289 18.7071L10.2929 21.7071C10.4804 21.8946 10.7348 22 11 22C11.2652 22 11.5196 21.8946 11.7071 21.7071L17.7071 15.7071Z"
												fill="#E5A42B"
											/>
										</svg>
										<span class="truncate">
											{{ file.name }}</span
										>
									</div>
									<a
										:href="file.asset_url"
										download
										target="_blank"
										class="flex items-center font-semibold text-sm text-blue-700 hover:text-blue-800 cursor-pointer ml-6 whitespace-nowrap"
									>
										<svg
											class="mr-2"
											width="20"
											height="20"
											viewBox="0 0 20 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M10 0C8.21698 0 6.6397 0.70057 5.5072 1.67727C4.54981 2.50296 3.85599 3.57713 3.67778 4.65625C1.58233 5.1189 0 6.94389 0 9.14773C0 11.7075 2.13442 13.75 4.72656 13.75H9.375V6.875C9.375 6.52982 9.65482 6.25 10 6.25C10.3452 6.25 10.625 6.52982 10.625 6.875V13.75H15.8594C18.1279 13.75 20 11.9619 20 9.71591C20 7.6707 18.4476 6.00513 16.4571 5.72373C16.1541 2.4993 13.3628 0 10 0Z"
												fill="currentColor"
											/>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M9.55806 19.8169C9.80214 20.061 10.1979 20.061 10.4419 19.8169L14.1919 16.0669C14.436 15.8229 14.436 15.4271 14.1919 15.1831C13.9479 14.939 13.5521 14.939 13.3081 15.1831L10.625 17.8661V13.75H9.375V17.8661L6.69194 15.1831C6.44786 14.939 6.05214 14.939 5.80806 15.1831C5.56398 15.4271 5.56398 15.8229 5.80806 16.0669L9.55806 19.8169Z"
												fill="currentColor"
											/>
										</svg>
										Tải xuống
									</a>
								</div>
							</div>
						</div>
						<div v-else>-</div>
					</div>
				</div>
				<div class="flex md-down:flex-col w-full gap-4 mt-8">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						ĐỐI TƯỢNG
					</div>
					<div class="w-full text-gray-700">
						{{ notification?.student?.name }}
					</div>
				</div>
				<div class="flex md-down:flex-col w-full gap-4 mt-8">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						THÁNG
					</div>
					<div class="w-full text-gray-700">
						<div v-if="notification?.month">
							{{ $filters.formatDateMMYYYY(notification?.month) }}
						</div>
						<div v-else>-</div>
					</div>
				</div>
				<div
					class="flex md-down:flex-col w-full gap-4 mt-8"
					v-if="notification?.notice?.state !== 'draft'"
				>
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						gửi lúc
					</div>
					<div class="w-full text-gray-700">
						<div v-if="notification.notice?.sent_at">
							{{
								$filters.formatDateTime(
									notification.notice?.sent_at
								)
							}}
						</div>
						<div v-else>-</div>
					</div>
				</div>
				<div
					class="flex md-down:flex-col w-full gap-4 mt-8"
					v-if="notification?.notice?.state !== 'draft'"
				>
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						tạo lúc
					</div>
					<div class="w-full text-gray-700">
						<div v-if="notification.notice?.inserted_at">
							{{
								$filters.formatDateTime(
									notification.notice?.inserted_at
								)
							}}
						</div>
						<div v-else>-</div>
					</div>
				</div>
				<div
					class="flex md-down:flex-col w-full gap-4 mt-8"
					v-if="notification?.notice.state !== 'draft'"
				>
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						người gửi
					</div>
					<div class="w-full text-gray-700">
						<div
							v-if="notification.notice?.sent_by_staff"
							@click="
								isAdmin &&
									$router.push(
										`/record/employee/${notification.notice?.sent_by_staff.id}`
									)
							"
							:class="{
								'cursor-pointer': isAdmin,
							}"
						>
							<div class="flex items-center">
								<img
									class="shadow-sm inline-block h-6 w-6 rounded-full"
									:src="
										notification.notice?.sent_by_staff
											?.profile_photo?.w200
									"
									v-if="
										notification.notice?.sent_by_staff
											?.profile_photo?.w200
									"
									alt=""
								/>
								<span
									v-else
									class="inline-flex items-center justify-center h-6 w-6 rounded-full"
									:style="{
										background:
											notification.notice?.sent_by_staff
												?.profile_photo?.default?.color,
									}"
								>
									<span
										class="font-medium leading-none text-white text-xs"
										>{{
											notification.notice?.sent_by_staff
												?.profile_photo?.default
												?.initial
										}}</span
									>
								</span>
								<div class="ml-4 text-blue-600 font-semibold">
									{{
										notification.notice?.sent_by_staff?.name
									}}
								</div>
							</div>
						</div>
						<div v-else>-</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bg-white rounded-xl p-6 shadow-sm mt-10">
			<div class="rounded-lg p-4 border border-gray-100 mt-4">
				<div class="flex md-down:flex-col w-full gap-4">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						gửi lúc
					</div>
					<div class="w-full text-gray-700">
						<div v-if="notification.notice?.sent_at">
							{{
								$filters.formatDateTime(
									notification.notice?.sent_at
								)
							}}
						</div>
						<div v-else>-</div>
					</div>
				</div>
				<div class="flex md-down:flex-col w-full gap-4 mt-8">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						tạo lúc
					</div>
					<div class="w-full text-gray-700">
						<div v-if="notification.notice?.inserted_at">
							{{
								$filters.formatDateTime(
									notification.notice?.inserted_at
								)
							}}
						</div>
						<div v-else>-</div>
					</div>
				</div>
				<div class="flex md-down:flex-col w-full gap-4 mt-8">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						người gửi
					</div>
					<div class="w-full text-gray-700">
						<div
							v-if="notification.notice?.sent_by_staff"
							:class="{
								'cursor-pointer': isAdmin,
							}"
							@click="
								isAdmin &&
									$router.push(
										`/record/employee/${notification.notice?.sent_by_staff.id}`
									)
							"
						>
							<div class="flex items-center">
								<img
									v-if="
										notification.notice?.sent_by_staff
											?.profile_photo?.w200
									"
									:src="
										notification.notice?.sent_by_staff
											?.profile_photo?.w200
									"
									alt=""
									class="shadow-sm inline-block h-6 w-6 rounded-full"
								/>
								<span
									v-else
									:style="{
										background:
											notification.notice?.sent_by_staff
												?.profile_photo?.default?.color,
									}"
									class="inline-flex items-center justify-center h-6 w-6 rounded-full"
								>
									<span
										class="font-medium leading-none text-white text-xs"
										>{{
											notification.notice?.sent_by_staff
												?.profile_photo?.default
												?.initial
										}}</span
									>
								</span>
								<div class="ml-4 text-blue-600 font-semibold">
									{{
										notification.notice.sent_by_staff?.name
									}}
								</div>
							</div>
						</div>
						<div v-else>-</div>
					</div>
				</div>
			</div>
		</div>
		<div
			class="mt-10 flex items-center justify-center md:justify-end"
			v-if="notification?.notice?.state === 'draft'"
		>
			<button
				type="button"
				class="button-p text-center w-fit px-10"
				@click="confirmSendOpen"
			>
				Gửi thông báo
			</button>
		</div>
		<div
			class="mt-10 flex items-center justify-center md:justify-end gap-6"
			v-else
		>
			<div
				class="flex items-center gap-1 cursor-pointer"
				@click="confirmWithdrawOpen"
				v-if="notification?.notice?.state !== 'withdrawn'"
			>
				<svg
					width="14"
					height="14"
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M6.00007 4.06758e-07C4.95912 -0.000350034 3.93598 0.270125 3.0312 0.784848C2.12641 1.29957 1.37111 2.04083 0.839493 2.9358C0.30788 3.83077 0.0182515 4.84864 -0.000933756 5.88942C-0.020119 6.93019 0.231799 7.95805 0.730067 8.872L0.020067 11.362C-0.00491574 11.4494 -0.0055812 11.542 0.0181421 11.6298C0.0418654 11.7176 0.0890792 11.7972 0.154702 11.8602C0.220325 11.9231 0.301872 11.967 0.390568 11.9871C0.479263 12.0071 0.571747 12.0026 0.658067 11.974L2.99607 11.195C3.46407 11.466 3.97207 11.675 4.50907 11.813C4.03457 10.7907 3.88561 9.64722 4.08236 8.53743C4.27911 7.42764 4.81207 6.4051 5.60909 5.60818C6.40612 4.81126 7.42874 4.27845 8.53856 4.08185C9.64837 3.88525 10.7918 4.03436 11.8141 4.509C11.483 3.21864 10.732 2.07514 9.67931 1.25875C8.62664 0.442363 7.33221 -0.000489938 6.00007 4.06758e-07ZM9.50007 14C10.091 14 10.6762 13.8836 11.2221 13.6575C11.7681 13.4313 12.2642 13.0998 12.682 12.682C13.0999 12.2641 13.4314 11.768 13.6575 11.2221C13.8837 10.6761 14.0001 10.0909 14.0001 9.5C14.0001 8.90905 13.8837 8.32389 13.6575 7.77793C13.4314 7.23196 13.0999 6.73588 12.682 6.31802C12.2642 5.90016 11.7681 5.56869 11.2221 5.34254C10.6762 5.1164 10.091 5 9.50007 5C8.30659 5 7.162 5.47411 6.31809 6.31802C5.47417 7.16193 5.00007 8.30653 5.00007 9.5C5.00007 10.6935 5.47417 11.8381 6.31809 12.682C7.162 13.5259 8.30659 14 9.50007 14ZM8.60407 7.604L7.70707 8.5H9.25007C9.6112 8.5 9.9688 8.57113 10.3024 8.70933C10.6361 8.84753 10.9392 9.05009 11.1946 9.30546C11.45 9.56082 11.6525 9.86397 11.7907 10.1976C11.9289 10.5313 12.0001 10.8889 12.0001 11.25V11.5C12.0001 11.6326 11.9474 11.7598 11.8536 11.8536C11.7599 11.9473 11.6327 12 11.5001 12C11.3675 12 11.2403 11.9473 11.1465 11.8536C11.0527 11.7598 11.0001 11.6326 11.0001 11.5V11.25C11.0001 10.7859 10.8157 10.3408 10.4875 10.0126C10.1593 9.68437 9.7142 9.5 9.25007 9.5H7.70707L8.60407 10.396C8.69795 10.4899 8.7507 10.6172 8.7507 10.75C8.7507 10.8828 8.69795 11.0101 8.60407 11.104C8.51018 11.1979 8.38284 11.2506 8.25007 11.2506C8.11729 11.2506 7.98995 11.1979 7.89607 11.104L6.14407 9.35C6.05121 9.25605 5.99929 9.12918 5.99967 8.99709C6.00004 8.86499 6.05268 8.73842 6.14607 8.645L7.89607 6.895C7.94255 6.84851 7.99774 6.81164 8.05848 6.78648C8.11922 6.76132 8.18432 6.74837 8.25007 6.74837C8.31581 6.74837 8.38091 6.76132 8.44165 6.78648C8.50239 6.81164 8.55758 6.84851 8.60407 6.895C8.65055 6.94149 8.68743 6.99668 8.71259 7.05742C8.73775 7.11816 8.7507 7.18326 8.7507 7.249C8.7507 7.31474 8.73775 7.37984 8.71259 7.44058C8.68743 7.50132 8.65055 7.55651 8.60407 7.603"
						fill="#E37056"
					/>
				</svg>
				<div class="notify">Thu hồi thông báo</div>
			</div>
			<button
				v-if="notification?.notice?.state !== 'withdrawn'"
				type="button"
				class="button-p text-center w-fit px-10"
				@click="confirmResendOpen"
			>
				Gửi lại thông báo
			</button>
		</div>
		<div v-if="parents.length > 0">
			<div class="text-lg text-neutral-600 font-semibold my-6">
				Lịch sử gửi thông báo học phí
			</div>
			<div class="shadow-sm sm:rounded-2xl">
				<div class="__record__table overflow-x-auto scroll-bar">
					<div
						class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
					>
						<table class="min-w-full divide-y text-neutral-200">
							<thead class="bg-neutral-100 h-16">
								<tr>
									<th
										class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
										scope="col"
									>
										STT
									</th>
									<th
										class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-32"
										scope="col"
									>
										người gửi
									</th>
									<th
										class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										scope="col"
									>
										gửi lúc
									</th>
									<th
										class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										scope="col"
									>
										Phụ Huynh đã xem
									</th>
									<th
										class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										style="width: 200px"
										scope="col"
									>
										Xem thông báo
									</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(person, personIdx) in parents"
									:key="person.id"
									:class="
										personIdx % 2 === 0
											? 'bg-white'
											: 'bg-neutral-50'
									"
									class="text-neutral-700"
								>
									<td>
										<div class="px-6 py-4 text-neutral-700">
											{{ personIdx + 1 }}
										</div>
									</td>
									<td
										class="px-6 py-4 whitespace-nowrap text-neutral-700"
									>
										<div class="w-full text-gray-700">
											<div
												v-if="person.sent_by_staff"
												:class="{
													'cursor-pointer': isAdmin,
												}"
												@click="
													isAdmin &&
														$router.push(
															`/record/employee/${person.sent_by_staff.id}`
														)
												"
											>
												<div class="flex items-center">
													<img
														v-if="
															person.sent_by_staff
																?.profile_photo
																?.w200
														"
														:src="
															person.sent_by_staff
																?.profile_photo
																?.w200
														"
														alt=""
														class="shadow-sm inline-block h-6 w-6 rounded-full"
													/>
													<span
														v-else
														:style="{
															background:
																person
																	.sent_by_staff
																	?.profile_photo
																	?.default
																	?.color,
														}"
														class="inline-flex items-center justify-center h-6 w-6 rounded-full"
													>
														<span
															class="font-medium leading-none text-white text-xs"
															>{{
																person
																	.sent_by_staff
																	?.profile_photo
																	?.default
																	?.initial
															}}</span
														>
													</span>
													<div
														class="ml-4 text-blue-600 font-semibold"
													>
														{{
															person.sent_by_staff
																?.name
														}}
													</div>
												</div>
											</div>
											<div v-else>-</div>
										</div>
									</td>
									<td
										class="px-6 py-4 whitespace-nowrap text-neutral-700"
									>
										<div v-if="person?.sent_at">
											{{
												$filters.formatDateTime(
													person?.sent_at
												)
											}}
										</div>
										<div v-else>-</div>
									</td>
									<td class="px-6 py-4 whitespace-nowrap">
										{{ person.view_count || 0 }} /
										{{ person.total_parent_received || 0 }}
									</td>
									<td
										class="px-6 py-4 whitespace-nowrap w-max"
									>
										<button
											@click="
												$router.push(
													`/fee-notices/${person.id}`
												)
											"
											type="button"
											class="button-p btn--ghost w-fit px-6 h-12"
										>
											Xem thông báo
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { $api } from '@/services';
import { ACTIONS } from '@/enums/Common';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame';
import ConfirmSendFeeNotice from '@/views/feeNoticesCreate/ConfirmSendFeeNotice';
import ConfirmResend from '@/views/feeNotoceDetail/features/ConfirmResend';
import DeleteConfirm from '@/views/notificationDetail/features/DeleteConfirm';
import { timeSince } from '@/helper/formatDate';
import { formatUrl } from '@/helper/formatUrl';
import ViewPhoto from '@/components/common/ViewPhoto';
import Withdraw from '@/views/feeNotoceDetail/features/Withdraw';
import CreateNotify from '../forms/CreateNotify.vue';

export default {
	name: 'FeeNoticeDetail',
	components: {
		ViewPhoto,
		DeleteConfirm,
		ConfirmResend,
		ConfirmSendFeeNotice,
		DaModalFrame,
		Withdraw,
		CreateNotify,
	},
	data() {
		return {
			modalIsOpen: false,
			modalType: false,
			notificationConfirm: null,
			notification: {},
			tuition: {},
			files: [],
			images: [],
			file: null,
			parents: [],
			lastSendAt: '',
			inProgress: false,
			imageShow: false,
			photosIndex: 0,
			forms: [],
			total: 0,
			open: false,
			sideOverShow: false,
			notice: {},
			data: {},
		};
	},

	computed: {
		id() {
			return this.$route.params.id || '';
		},

		type() {
			return ACTIONS;
		},

		isAdmin() {
			return this.$store.getters.isAdmin;
		},
		senderName() {
			return this.$store.state.profile.staff.name;
		},
		currentOrg() {
			return this.$store.state.profile.current_org;
		},
	},
	watch: {
		'$route.params.id': {
			handler: function () {
				if (!this.$route.params.id) return;
				this.forms = [];
				this.fetchNotification();
			},
			deep: true,
			immediate: true,
		},
	},
	// created() {
	// 	this.fetchNotification();
	// },
	methods: {
		formatUrl,
		async fetchNotification() {
			try {
				const res = await $api.notification.getFeeNotification(this.id);
				this.notification = res?.data?.data;
				this.tuition =
					this.notification?.notice?.student_tuition_from_template;
				this.data =
					this.notification?.notice?.student_tuition_from_template?.data?.other_components_and_settings;
				if (this.tuition !== null) {
					this.forms.push(
						this.tuition?.data?.fee.default,
						this.tuition?.data?.refund?.default
					);
					if (this.tuition?.data?.fee?.other.length > 0) {
						this.tuition?.data?.fee?.other.map((i) =>
							this.forms[0].push(i)
						);
					}
					if (this.tuition?.data?.refund?.other.length > 0) {
						this.tuition?.data?.refund?.other.map((i) =>
							this.forms[1].push(i)
						);
					}
					this.forms[0].total = this.tuition.data?.fee?.total;
					this.forms[1].total = this.tuition.data?.refund?.total;
					this.total = this.tuition.data?.total;
				}
				this.files =
					this.notification.notice?.notice_attachments?.filter(
						(i) => !i.is_image
					) || [];
				this.images =
					this.notification.notice?.notice_attachments?.filter(
						(i) => i.is_image
					) || [];

				if (
					this.notification.notice?.attachment_photo &&
					this.notification.notice?.attachment_photo?.w1000
				) {
					this.images.push({
						id: this.notification.notice?.attachment_photo?.w1000,
						asset_key:
							this.notification.notice?.attachment_photo?.w1000,
						asset_url:
							this.notification.notice?.attachment_photo?.w1000,
					});
				}
				if (
					this.notification.notice?.attachment_file &&
					this.notification.notice?.attachment_file?.file?.original
				) {
					this.files.push({
						id: this.notification.notice?.attachment_file?.file
							?.original,
						asset_key:
							this.notification.notice?.attachment_file?.file
								?.original,
						asset_url:
							this.notification.notice?.attachment_file?.file
								?.original,
						name: this.notification.notice?.attachment_file
							?.file_name,
					});
				}
				await this.fetchParentReadNotification();
			} catch (err) {
				console.log(err);
			}
		},

		async deleteNotification() {
			this.inProgress = true;
			try {
				await $api.notification.deleteFeeNotification(this.id);
				await this.$router.push('/fee-notices');
				this.$store.dispatch('setAlertMessage', {
					message: 'Xoá thông báo thành công',
				});
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.inProgress = false;
			}
		},

		deleteOpen() {
			this.modalIsOpen = true;
			this.modalType = this.type.DELETE;
		},

		async fetchParentReadNotification() {
			try {
				const {
					data: { data },
				} = await $api.notification.historySendFeeNotification(
					this.notification?.tuition_notice_id
				);
				this.parents = data;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},
		getTotal(arr) {
			let sum = 0;
			for (let card of arr)
				sum = sum + card.fields[0].value * card.fields[1].value;
			return sum;
		},
		async sendNotification() {
			this.inProgress = true;
			try {
				await $api.notification.sendSaveFeeNotification(
					this.notification?.notice?.id
				);
				this.cancel();
				this.$store.dispatch('setAlertMessage', {
					message: 'Gửi thông báo thành công',
				});
				this.$router.push('/fee-notices');
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.inProgress = false;
			}
		},

		confirmSendOpen() {
			this.modalIsOpen = true;
			this.modalType = this.type.CREATE;
			this.notificationConfirm = {
				name: this.notification?.student?.name,
				title: this.notification?.notice?.title,
				money: this.total,
				sender: this.senderName,
			};
		},
		confirmWithdrawOpen() {
			this.open = true;
		},
		confirmResendOpen() {
			if (this.notification.lastest_notice_sent_at) {
				this.lastSendAt = timeSince(
					this.notification.lastest_notice_sent_at
				);
			}
			this.modalIsOpen = true;
			this.modalType = this.type.UPDATE;
		},

		async reSendNotification() {
			this.inProgress = true;
			try {
				await $api.notification.reSendFeeNotification(
					this.notification.tuition_notice_id
				);
				this.cancel();
				this.forms = [];
				await this.fetchNotification();
				await this.fetchParentReadNotification();
				this.$store.dispatch('setAlertMessage', {
					message: 'Gửi thông báo thành công',
				});
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.inProgress = false;
			}
		},

		cancel() {
			this.modalIsOpen = false;
			this.modalType = '';
			this.open = false;
		},

		openMediaPopup(index) {
			this.imageShow = true;
			this.photosIndex = index;
		},
		async withdrawFeeNotification() {
			this.inProgress = true;
			try {
				await $api.notification.withdrawNotification(this.id);
				this.cancel();
				await this.fetchNotification();
				this.$store.dispatch('setAlertMessage', {
					message: 'Thông báo học phí đã được thu hồi thành công',
				});
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.inProgress = false;
			}
		},
		editNotify() {
			this.notice = {
				form: this.tuition?.tuition_template_id,
				student: this.tuition?.student,
				month: this.notification?.month,
				tuitionId: this.tuition.id,
				note: this.tuition.note,
				noticeId: this.notification?.notice?.id,
			};
			this.sideOverShow = true;
		},
		formatData(data) {
			const date = new Date(data);
			const day = date.getDate();
			const month = date.getMonth() + 1;
			const year = date.getFullYear();
			return `Ngày ${day} tháng ${month} năm ${year}`;
		},
	},
};
</script>
<style lang="scss" scoped>
.title {
	font-weight: 600;
	box-shadow: none !important;

	&::placeholder {
		font-weight: normal;
	}
}
.w-statistic {
	width: calc(50% - 8px);
}
</style>
